import React, { useContext } from "react";
import { FilterArea, StackedBarchart, OverheadsDataTable, DataQualityLegend } from "@sia/style-guide";
import { usePageRefresh } from "../tools";
import { companyHasOwnValues, parseOverheadsTableData, parseStackedbarChartData } from "./data/dataParsing";
import { MasterKeyContext } from "contexts/MasterKeyContext";
import { updateOverheadPageFilters } from "./stateUpdaters";
import { generateOverheadTableHeader, getActiveOrAllOfficeSizeItems, getActiveRefId } from "./helpers";
import "./OverheadsPage.scss";
export default function OverheadsPage({ translate, filters, setFilters, data, selectedTab, setSelectedTab }) {
  if (!data.overheadsAllocationPerPeriod) {
    return null;
  }
  const OVERHEADS_PAGE_TAB_INDEX = 1;
  usePageRefresh(selectedTab, OVERHEADS_PAGE_TAB_INDEX, setSelectedTab);

  const { isMasterKeyValid } = useContext(MasterKeyContext);
  let hasOwnValues = companyHasOwnValues(data);

  hasOwnValues = hasOwnValues && !!isMasterKeyValid;

  let stackedBarchartData = parseStackedbarChartData(data, hasOwnValues);

  let refIndex = getActiveRefId(filters);

  let officeSizeItems = getActiveOrAllOfficeSizeItems(filters);

  let tableHeaderRows = generateOverheadTableHeader(translate, officeSizeItems, hasOwnValues);
  let tableData = parseOverheadsTableData(data, refIndex, hasOwnValues, officeSizeItems, translate);

  return (
    <div className="benchmarking-overheads-container sia-padding-02-left sia-padding-02-right" id="sia-overheads-page">
      <p className="title sia-text-15 sia-padding-06-top sia-padding-06-bottom">{translate("benchmarking.evaluations.overheads.title")}</p>
      {filters && (
        <FilterArea
          translate={translate}
          initialFilters={filters}
          onFiltersUpdate={(filterAreaState) => {
            updateOverheadPageFilters(setFilters, filterAreaState);
          }}
        />
      )}
      <div className="sia-padding-05-top">
        <StackedBarchart
          translate={translate}
          bandWidth={50}
          data={stackedBarchartData}
          isPercentage
          options={{
            gradients: {
              ownValue: ["#e41a11"],
              average: ["#000000"],
            },
          }}
          refIndex={refIndex}
        />
      </div>
      <div className="sia-padding-05-top">
        <OverheadsDataTable headerRows={tableHeaderRows} dataRows={tableData} />
        <DataQualityLegend translate={translate} />
      </div>
    </div>
  );
}
